export enum PathEnum {
  PAGES = '/pages',
  CONTESTO = '/c', // prefisso rotte contestuali `/c/:comuneSlug/:servizioSlug/<sezione>`
  LOGIN = '/login',
  REGISTRAZIONE = '/registrazione',
  HOME = '/home',
  PROFILE = '/profile',
  LOGOUT = '', //non c'è una page di logout
  RECOVER_PASSWORD = '/recover-password',
  FIGLI = '/children',
  PORTAFOGLIO = '/portafoglio',
  CALENDARIO = '/calendario',
  MENU = '/menu',
  RICARICHE = '/ricariche',
  PAGAMENTI_MENSA = '/pagamenti-mensa',
  STUDENTI_MENSA = '/studenti-mensa',
  TARIFFE_MENSA = '/tariffe-mensa',
  VERIFY_ACCOUNT = '/verify-account',
  ENABLE_ACCOUNT = '/enable-account',
  BANDI = '/bandi',
  PRATICHE = '/pratiche',
  PRATICA_NUOVA = '/pratiche/nuova',
  PRATICA_ELIGIBILITA = '/pratiche/eligibilita',
  PRATICA_OTP_SUFFIX = '/otp',
  MIE_PRATICHE = '/mie-pratiche',
  MIEI_SERVIZI = '/miei-servizi',
  MIEI_VOUCHER = '/miei-voucher',
  MIE_ISEE = '/mie-isee',
  // @deprecated MENSA legacy — pagine sganciate dal routing (add-cittadino-pratiche-vista). Enum mantenuti finché i file legacy non vengono rimossi in un cleanup dedicato.
  PRATICA = '/pratica',
  STATO_PRATICA = '/stato-pratica',
  DETTAGLIO_PRATICA = '/dettaglio-pratica',
  SELEZIONE_COMUNE = '/selezione-comune',
  COMUNI = '/comuni',
  ONBOARDING_PROFILO = '/onboarding/completa-profilo',
  ONBOARDING_COMUNE = '/onboarding/scegli-comune',
  // ⚠️ PUNTO DI RACCORDO, NON una rotta funzionante: la rotta dell'area operatore è in corso di
  // Login dedicato dell'area operatore: pagina propria, fuori dal login del cittadino. Stesso
  // motore di autenticazione (`AutenticazioneService.loginOperatore`), testi e destinazione
  // diversi. Chi non ha un ruolo operatore viene respinto qui, senza entrare nell'area.
  OPERATORE_LOGIN = '/operatore/login',
  // Punto d'ingresso dell'area operatore di backoffice: la lista dei bandi su cui può compilare.
  // Serve a `OnboardingRouterService` per non instradare un operatore sull'onboarding del profilo
  // cittadino — un percorso che gli chiederebbe dati che non gli competono (un operatore non ha
  // un profilo cittadino, quindi cadrebbe nel ramo `userProfile == null`).
  //
  // ⚠ È una rotta TOP-LEVEL, fuori da `/pages`: la shell del cittadino monta menu, header e la
  // discovery mensa (`StudentiMensaService`), tutte cose che per un operatore sono inutili e che
  // chiamano endpoint `/cittadino/*` a cui lui non ha accesso. Registrata in `app.routes.ts`.
  OPERATORE_HOME = '/operatore',
  // Compilazione di una domanda da parte di un OPERATORE per conto di un cittadino: figlia di
  // `OPERATORE_HOME`, registrata in `app.routes.ts`. Va completata con `/{slug}/{idTp}`,
  // dove `idTp` è l'UUID del bando e NON il codice parlante: l'endpoint di gestione del submit
  // risolve il bando solo dall'UUID (difesa multi-tenant, il bando non è mai letto dal form).
  OPERATORE_PRATICA_NUOVA = '/operatore/pratiche/nuova',
  AUTH_CALLBACK = '/auth/callback',
  AUTH_ERROR = '/auth/error',
  CONTATTI = '/contatti',
}

export enum IconMenuEnum {
  LOGIN = 'log-in-outline',
  HOME = 'home-outline',
  PROFILE = 'person-circle-outline',
  LOGOUT = 'log-out-outline',
  FIGLI = 'people-outline',
  PORTAFOGLIO = 'wallet-outline',
  CALENDARIO = 'calendar-outline',
  MENU = 'document-text-outline',
  RICARICHE = 'card-outline',
  TARIFFE = 'pricetag-outline',
  SERVIZI = 'apps-outline',
  PRATICHE = 'clipboard-outline',
  MIE_PRATICHE = 'reader-outline',
  MIEI_VOUCHER = 'ticket-outline',
  // @deprecated MENSA legacy
  STATO_PRATICA = 'document-attach-outline',
  SELEZIONE_COMUNE = 'swap-horizontal-outline',
  CONTATTI = 'mail-outline',
}

// NB: qui viveva `LabelMenuEnum`, un registro di etichette di menu in italiano hardcoded.
// Rimosso: le etichette sono CHIAVI Transloco risolte al punto d'uso (`common.nav.*`), vedi
// `shared/constants/capability-menu.const.ts` (menu) e `pages/pages.page.ts` (header globale).
// Un enum di testo qui congelerebbe le etichette alla lingua di build.

export enum RoutesEnum {
  PAGES = 'pages',
  LOGIN = 'login',
  REGISTRAZIONE = 'registrazione',
  HOME = 'home',
  PROFILE = 'profile',
  RECOVER_PASSWORD = 'recover-password',
  FIGLI = 'children',
  PORTAFOGLIO = 'portafoglio',
  CALENDARIO = 'calendario',
  MENU = 'menu',
  RICARICHE = 'ricariche',
  PAGAMENTI_MENSA = 'pagamenti-mensa',
  STUDENTI_MENSA = 'studenti-mensa',
  TARIFFE_MENSA = 'tariffe-mensa',
  VERIFY_ACCOUNT = 'verify-account',
  ENABLE_ACCOUNT = 'enable-account',
  BANDI = 'bandi',
  PRATICHE = 'pratiche',
  MIE_PRATICHE = 'mie-pratiche',
  MIEI_SERVIZI = 'miei-servizi',
  MIEI_VOUCHER = 'miei-voucher',
  MIE_ISEE = 'mie-isee',
  // @deprecated MENSA legacy
  PRATICA = 'pratica',
  STATO_PRATICA = 'stato-pratica',
  DETTAGLIO_PRATICA = 'dettaglio-pratica',
  SELEZIONE_COMUNE = 'selezione-comune',
  COMUNI = 'comuni',
  ONBOARDING = 'onboarding',
  ONBOARDING_PROFILO = 'onboarding/completa-profilo',
  ONBOARDING_COMUNE = 'onboarding/scegli-comune',
  // Segmento base dell'area operatore di backoffice: rotta TOP-LEVEL, non più sotto `/pages`
  // (vedi PathEnum.OPERATORE_HOME per il perché).
  OPERATORE = 'operatore',
  // Login dedicato dell'area operatore, figlio di `OPERATORE`.
  OPERATORE_LOGIN = 'login',
  AUTH_CALLBACK = 'auth/callback',
  AUTH_ERROR = 'auth/error',
  CONTATTI = 'contatti',
}


